<!-- src/components/GIGUserGridModal.vue -->
<template>
  <v-dialog :model-value="show" @update:model-value="$emit('update:show', $event)" max-width="900px">
    <v-card>
      <v-card-title>
        GIG User Information
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          class="mx-4"
        ></v-text-field>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="gigUsers"
          :search="search"
          :items-per-page="10"
          :page="page"
          hide-default-footer
          class="elevation-1"
        >
          <template #[`item.actions`]="{ item }">
            <v-btn small text color="primary" @click="selectUser(item)">Select</v-btn>
          </template>
        </v-data-table>
        <div class="d-flex justify-center pt-4">
          <v-pagination
            v-model="page"
            :length="Math.ceil(gigUsers.length / 10)"
            :total-visible="7"
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref, onMounted } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'GIGUserGridModal',
  props: {
    show: Boolean,
  },
  emits: ['close', 'select', 'update:show'],
  setup(props, { emit }) {
    const store = useStore()
    const search = ref('')
    const page = ref(1)

    const headers = [
      { text: 'Name', value: 'mber_nm' },
      { text: 'Department', value: 'dept_dv_code_nm' },
      { text: 'Position', value: 'dty_dv_code_nm' },
      { text: 'Grade', value: 'grd_dv_code_nm' },
      { text: 'Email', value: 'email' },
      { text: 'Actions', value: 'actions', sortable: false },
    ]

    const gigUsers = computed(() => store.getters['user/allGigUsers'])

    const close = () => {
      emit('update:show', false)
      emit('close')
    }

    const selectUser = (user) => {
      emit('select', user)
    }

    onMounted(() => {
      store.dispatch('user/fetchGigUsers')
    })

    return {
      headers,
      gigUsers,
      search,
      page,
      close,
      selectUser,
    }
  }
}
</script>
